import { ROUTES } from './routesEnums';
import { Provider } from '../views/provider/Provider';
import { ProvidersQuarantine } from '../views/provider/ProvidersQuarantine';
import { PROVIDERS_TABS } from './routing-helper/provider-navigation';

export const PROVIDERS_BASE_URL = `${ROUTES.ADMIN}${ROUTES.PROVIDERS}`;
export const providersRoutes = [
  {
    key: PROVIDERS_TABS.PROCESSING,
    pathname: `${PROVIDERS_BASE_URL}${ROUTES.PROCESSING}`,
    component: <Provider />,
  },
  {
    key: PROVIDERS_TABS.QUARANTINED,
    pathname: `${PROVIDERS_BASE_URL}${ROUTES.QUARANTINED}`,
    component: <ProvidersQuarantine />,

  },
];

export const getInitialProvidersNavTab = (pathname: string): PROVIDERS_TABS => {
  switch (pathname) {
    case `${PROVIDERS_BASE_URL}${ROUTES.QUARANTINED}`:
      return PROVIDERS_TABS.QUARANTINED;
    case `${PROVIDERS_BASE_URL}${ROUTES.PROCESSING}`:
      return PROVIDERS_TABS.PROCESSING;
    default:
      return PROVIDERS_TABS.PROCESSING;
  }
};